import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const listReportsV2 = gql`
  query ListReportsV2Query($input: ListReportsV2!) {
    listReportsV2(input: $input) {
      hasMore
      reports {
        ...Report
      }
    }
  }

  ${Fragments.report.report}
`;
